"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.relativeDate = void 0;
var relativeDate = function relativeDate(input) {
  var today = new Date();
  var now = new Date();
  var timeUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds())).getTime();
  var date = new Date(input);
  var monthDiff = date.getMonth() - today.getMonth() + 12 * (date.getFullYear() - today.getFullYear());
  var diffInSeconds = (date.getTime() - timeUTC) / 1000;
  var yearDiff = date.getFullYear() - today.getFullYear();
  var day = 86400;
  var message = '';
  var close = false;
  if (yearDiff > 1) {
    message = "".concat(yearDiff, " years left");
  } else if (yearDiff === 1 && monthDiff >= 12) {
    message = "".concat(yearDiff, " year left");
  } else if (diffInSeconds / day > 89) {
    message = "".concat(monthDiff, " months left");
  } else if (diffInSeconds > day) {
    message = "".concat(Math.ceil(diffInSeconds / day), " days left");
  } else if (diffInSeconds < day && diffInSeconds > 0) {
    message = 'Due Today';
  } else if (diffInSeconds < 0) {
    message = 'Closed';
    close = true;
  }
  return {
    message: message,
    close: close
  };
};
exports.relativeDate = relativeDate;